import moment from 'moment';

import ConversationItemType from 'models/conversation_item_type';

// We began retaining all Sidekick Conversations on June 7th, 2025. Only summaries after
// that date have a retained conversation to link to.
const SIDEKICK_RETENTION_START = '2025-06-07';

export default function canViewSidekickConversation(context, item) {
  if (item.contentType() !== ConversationItemType.MESSAGE_AUTOMATION_SUMMARY) {
    return false;
  }

  if (!context.isFeatureEnabled('sidekickConversationManagement')) {
    return false;
  }

  return moment(item.timestamp).isAfter(moment(SIDEKICK_RETENTION_START));
}
